import { Source, Marker, useMap } from 'react-map-gl';
import { useState } from 'react';
import { Pin } from '../../assets/Pin';
import { Button } from '@chakra-ui/react';
import { RegionSelectMenu } from './RegionSelectMenu';

const Regions = (props) => {
    const { mapLocation, regionsGeoJson } = props;
    const { current: map } = useMap();
    const [selectedRegion, setSelectedRegion] = useState(null);

    const handleRegionMarkerSelection = (region) => {
        map.flyTo({
            center: [region.centroid.longitude, region.centroid.latitude],
            zoom: 6.5
        });
        setSelectedRegion(region.name);
    };

    return (
        <> 
            <RegionSelectMenu selectedRegionPin={selectedRegion} regionsGeoJson={regionsGeoJson} mapLocation={mapLocation} />
            <Source type="geojson">
                {(mapLocation.zoom < 6.5 || Object.keys(mapLocation)?.length === 0) && regionsGeoJson.data?.regions?.map((region) => (
                    <Marker
                        key={region.id}
                        style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            zIndex: 11,
                        }}
                        longitude={region.centroid.longitude}
                        latitude={region.centroid.latitude}
                        onClick={() => handleRegionMarkerSelection(region)}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button
                                backgroundColor={'white'}
                                _hover={{ bg: 'teal.100' }}
                                color={'black'}
                                marginBottom={2}
                                shadow={'md'}
                            >
                                {region.name}
                            </Button>
                            <Pin />
                        </div>
                    </Marker>
                ))}
            </Source>
        </>
    )
}

export default Regions;